import cx from "classnames"
import { camelize } from "../../utils"
import type { IconColorsType } from "../"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "profilePicture"
const ProfilePictureIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`c-fill-${camelize(color || "")}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    },
  )
  return (
    <span className={computedClassName}>
      {
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
          <title>{iconSource}</title>
          <path d="M10.582 11.727C10.757 11.929 10.972 12.09 11.215 12.203 11.457 12.315 11.72 12.373 11.988 12.375S12.52 12.321 12.764 12.212C13.008 12.104 13.225 11.944 13.403 11.744L13.683 11.993 13.965 12.242C13.716 12.522 13.411 12.745 13.07 12.897S12.358 13.127 11.984 13.125 11.24 13.04 10.9 12.884C10.561 12.727 10.26 12.5 10.014 12.217L10.298 11.973zM10.125 8.625C10.539 8.625 10.875 8.961 10.875 9.375S10.539 10.125 10.125 10.125 9.375 9.789 9.375 9.375 9.711 8.625 10.125 8.625M13.875 8.625C14.289 8.625 14.625 8.961 14.625 9.375S14.289 10.125 13.875 10.125 13.125 9.789 13.125 9.375 13.461 8.625 13.875 8.625" />
          <path
            fillRule="evenodd"
            d="M18.75 1.5C19.578 1.5 20.25 2.172 20.25 3V21C20.25 21.828 19.578 22.5 18.75 22.5H5.25C4.422 22.5 3.75 21.828 3.75 21V3C3.75 2.172 4.422 1.5 5.25 1.5zM12.03 16.5C9.528 16.492 7.113 17.413 5.25 19.078V21H18.75V19.078C16.904 17.428 14.514 16.508 12.03 16.5M5.25 17.161C6.571 16.22 8.073 15.565 9.657 15.24 7.72 14.35 6.375 12.395 6.375 10.125 6.375 7.018 8.893 4.5 12 4.5S17.625 7.018 17.625 10.125C17.625 12.395 16.278 14.35 14.341 15.239 15.926 15.565 17.429 16.219 18.75 17.16V3H5.25zM12 6C9.722 6 7.875 7.847 7.875 10.125S9.722 14.25 12 14.25 16.125 12.403 16.125 10.125 14.278 6 12 6"
            clipRule="evenodd"
          />
        </svg>
      }
    </span>
  )
}
export default ProfilePictureIcon
